/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_F1Inputs */

const en_mk_sol_ukm_f1 = /** @type {(inputs: Mk_Sol_Ukm_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 back-office staff, 5 branch heads`)
};

const id_mk_sol_ukm_f1 = /** @type {(inputs: Mk_Sol_Ukm_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 orang kantor, 5 kepala cabang`)
};

/**
* | output |
* | --- |
* | "4 back-office staff, 5 branch heads" |
*
* @param {Mk_Sol_Ukm_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_f1 = /** @type {((inputs?: Mk_Sol_Ukm_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_f1(inputs)
	return en_mk_sol_ukm_f1(inputs)
});